module.exports = __webpack_public_path__ + "dc1f6adde4c84d40f0adeac06d2a4238.pdf";